import { render, staticRenderFns } from "./reason_modification.vue?vue&type=template&id=675e32b9&"
import script from "./reason_modification.vue?vue&type=script&lang=js&"
export * from "./reason_modification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports